import { api, ApiError } from 'utils/api';
import { userProfileSchema, userProfileAvatarSchema } from 'types/userProfile';

// Le profil est servi par Maestro (docs/maestro/RESTAPI.md §2.5), derrière la même passerelle que les
// accès de connexion et les rapports conseillers.
const MAESTRO = import.meta.env.VITE_ADVISOR_REPORT_SERVICE_URL!;

// L'avatar est servi par datarepo (docs/datarepo/RESTAPI-DATAREPO.md §3.12). Le reste du profil n'y
// est pas repris.
const DATAREPO = import.meta.env.VITE_DATAREPO_SERVICE_URL!;

type AvatarImage = {
  imageContent: string;
  fileExtension: string;
};

export const profileService = {
  // Sans avatar, datarepo répond `404` : c'est l'absence d'image, pas une panne.
  getProfileAvatar: () =>
    api
      .get<unknown>(DATAREPO, 'avatar/me')
      .then(d => userProfileAvatarSchema.nullable().catch(null).parse(d))
      .catch(error => {
        if (error instanceof ApiError && error.status === 404) return null;
        throw error;
      }),

  getProfileInfo: () => api.get<unknown>(MAESTRO, 'userProfile/me').then(d => userProfileSchema.parse(d)),

  updateProfileAvatar: ({ imageContent, fileExtension }: AvatarImage) =>
    api.put<void>(DATAREPO, 'avatar/me', { contentBase64: imageContent, fileExtension }),
};
